import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ITEM_REVENUE_CATEGORY } from 'src/app/helpers/item-revenue.helper';
import { LENS_TYPES } from 'src/app/helpers/lenses.helper';
import { ORDER_CATEGORY } from 'src/app/helpers/order-categories.helper';
import { CompanyLenses } from 'src/app/models/company-lenses.model';
import { ProductDataSubject } from 'src/app/models/product-data-subject.model';
import { ItemDetailsRequest } from 'src/app/models/requests/item-details-request.model';
import { CartManagerService } from 'src/app/services/local/cart-manager.service';
import { OrderManagerService } from 'src/app/services/local/order-manager.service';
import { CompanyComputerLensesService } from 'src/app/services/repositories/company-computer-lenses.service';
import { CompanyDressLensesService } from 'src/app/services/repositories/company-dress-lenses.service';
import { CompanyLensesService } from 'src/app/services/repositories/company-lenses.service';

@Component({
    selector: 'app-non-prescription',
    templateUrl: './non-prescription.component.html',
    styleUrls: ['./non-prescription.component.scss'],
    standalone: false
})
export class NonPrescriptionComponent implements OnInit {
  toggleClass: boolean = true;
  selectedLens: CompanyLenses | undefined;
  planoLens: CompanyLenses | undefined;
  currentParentClass = "lens-module";
  productNameParam: string | null | undefined;
  lenses: { lensId: number; strength: string }[] = [];
  tempCartEventsSubject: Subject<ProductDataSubject> = new Subject<ProductDataSubject>();
  isEditMode: boolean = false;
  queryParams: {} = {};

  constructor(private _router: Router,
              private _route: ActivatedRoute,
              private _cartManagerService: CartManagerService,
              private _companyLensesService: CompanyLensesService,
              private _companyComputerLensesService: CompanyComputerLensesService,
              private _companyDressLensesService: CompanyDressLensesService,
              public _orderManagerService: OrderManagerService) { }


  ngOnInit(): void {
    this._route.queryParams
    .subscribe(params => {
      this.isEditMode = params.isEditMode === 'true';
      this.queryParams = this.isEditMode ? {'isEditMode' : this.isEditMode} : {};
      this.getNonPrescriptionLenses();
    });
  }

  getNonPrescriptionLenses() {
    const cartItem = this._cartManagerService.getTempCartItem();
    let lensObservable: any;
    if (cartItem) {
      switch (cartItem?.itemCategory) {
        case ORDER_CATEGORY.glasses:
          lensObservable = this._companyLensesService.getLenses(LENS_TYPES.plano);
          break;
        case ORDER_CATEGORY.computerGlasses:
          lensObservable = this._companyComputerLensesService.getLenses(LENS_TYPES.plano);
          break;
        case ORDER_CATEGORY.dressGlasses:
          lensObservable = this._companyDressLensesService.getLenses(LENS_TYPES.plano);
          break;
        default:
          this.redirectToDashboard();
      }
      lensObservable.subscribe((data: CompanyLenses[]) => {
        if (data) {
          this.planoLens = data[0];
          this.selectLens();
        }
      }, (error: any) => {
        console.log(error);
      });
    }
    else {
      this.redirectToDashboard();
    }
  }

  redirectToDashboard() {
    this._router.navigate(['/dashboard']);
  }

  selectLens() {
    if (this.planoLens) {
      const cartItemDetail : ItemDetailsRequest = {
        id: this.planoLens.lensId,
        itemType: ITEM_REVENUE_CATEGORY.lenses,
        itemDescription: this.planoLens.lensDescription
      };
      this._cartManagerService.updateTempCartItemDetail(cartItemDetail);
      this.emitChangeToProductData();
    }
  }

  back() {
    this._cartManagerService.removeTempCartItemDetailByItemType(ITEM_REVENUE_CATEGORY.lenses);
    this._router.navigate(['/lens-selection'], { queryParams: this.queryParams });
  }

  emitChangeToProductData() {
    let pds: ProductDataSubject = { status: 'lens-update' };
    this.tempCartEventsSubject.next(pds);
  }

}
